import { Box, BoxProps, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

import { FileItem } from "@/common/fileItem";

import { ImageComparisonThumbnailList } from "./ImageComparisonThumbnailList";

export interface ImageComparisonSidePanelProps {
  title: ReactNode;
  subtitle?: ReactNode;
  images: FileItem[];
  selectedId?: string;
  headerSlot?: ReactNode;
  sx?: BoxProps["sx"];
  onSelect: (file: FileItem) => void;
}

export function ImageComparisonSidePanel({
  title,
  subtitle,
  images,
  selectedId,
  headerSlot,
  sx,
  onSelect,
}: ImageComparisonSidePanelProps) {
  return (
    <Stack
      spacing={1}
      sx={{
        // minWidth: 220,
        // maxWidth: 320,
        height: "100%",
        overflow: "hidden",
        ...sx,
      }}
    >
      <Box>
        <Typography variant='subtitle1'>{title}</Typography>

        {subtitle && <Typography variant='body2'>{subtitle}</Typography>}
      </Box>

      {headerSlot}

      <Box sx={{ flex: 1, minHeight: 0 }}>
        <ImageComparisonThumbnailList images={images} selectedId={selectedId} onSelect={onSelect} />
      </Box>
    </Stack>
  );
}
